export const PAGE_TOP_PADDING = 32;
export const ASIDE_TOP_MARGIN = 42;
export const SAFE_MARGIN = 80;
